import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class LoadingService {
  private _isLoading = new BehaviorSubject<boolean>(false);
  private _enabled = true;

  isLoading$: Observable<boolean>;

  get isLoading(): boolean {
    return this._isLoading.value;
  }

  private _counter = 0;

  constructor() {
    this.isLoading$ = this._isLoading
      .asObservable()
      .pipe(debounceTime(100), distinctUntilChanged());
  }

  setEnabled(enable: boolean) {
    this._enabled = enable;
  }

  start() {
    if (!this._enabled) {
      return;
    }
    this._counter++;
    if (this._counter === 1) {
      this._isLoading.next(true);
    }
  }

  finish() {
    if (this._counter > 0) {
      this._counter--;

      if (this._counter === 0) {
        this._isLoading.next(false);
      }
    }
  }
}
